export const adminState = {
  template: {},
  loggedIn: false,
  feideLoggedIn: false,
  loginProcess: false,
  logininformation: {},
  environment: 'dev',
  registryurl: '',
  serverurl: '',
  language: 'nb',
  activenavitem: -1,
  sitelanguage: 'nb',
  translationMap: new Map(),
  langCodesMap: new Map(),
  languagecodes: [
    { code: 'nb', langname: 'Norsk bokmål' },
    { code: 'nn', langname: 'Norsk nynorsk' },
    { code: 'smi', langname: 'Norsk samisk' },
    { code: 'en', langname: 'English' },
    { code: 'se', langname: 'Svenska' },
    { code: 'af', langname: 'Afrikaans' },
    { code: 'sq', langname: 'Albanian' },
    { code: 'am', langname: 'Amharic' },
    { code: 'ar', langname: 'Arabic' },
    { code: 'hy', langname: 'Armenian' },
    { code: 'az', langname: 'Azerbaijani' },
    { code: 'eu', langname: 'Basque' },
    { code: 'be', langname: 'Belarusian' },
    { code: 'bn', langname: 'Bengali' },
    { code: 'bs', langname: 'Bosnian' },
    { code: 'bg', langname: 'Bulgarian' },
    { code: 'ca', langname: 'Catalan' },
    { code: 'ceb', langname: 'Cebuano' },
    { code: 'ny', langname: 'Chichewa' },
    { code: 'zh-CN', langname: 'Chinese (Simplified)' },
    { code: 'zh-TW', langname: 'Chinese (Traditional)' },
    { code: 'co', langname: 'Corsican' },
    { code: 'hr', langname: 'Croatian' },
    { code: 'cs', langname: 'Czech' },
    { code: 'da', langname: 'Danish' },
    { code: 'nl', langname: 'Dutch' },
    { code: 'en', langname: 'English' },
    { code: 'eo', langname: 'Esperanto' },
    { code: 'et', langname: 'Estonian' },
    { code: 'tl', langname: 'Filipino' },
    { code: 'fi', langname: 'Finnish' },
    { code: 'fr', langname: 'French' },
    { code: 'fy', langname: 'Frisian' },
    { code: 'gl', langname: 'Galician' },
    { code: 'ka', langname: 'Georgian' },
    { code: 'de', langname: 'German' },
    { code: 'el', langname: 'Greek' },
    { code: 'gu', langname: 'Gujarati' },
    { code: 'ht', langname: 'Haitian Creole' },
    { code: 'ha', langname: 'Hausa' },
    { code: 'haw', langname: 'Hawaiian' },
    { code: 'he', langname: 'Hebrew' },
    { code: 'hi', langname: 'Hindi' },
    { code: 'hmn', langname: 'Hmong' },
    { code: 'hu', langname: 'Hungarian' },
    { code: 'is', langname: 'Icelandic' },
    { code: 'ig', langname: 'Igbo' },
    { code: 'id', langname: 'Indonesian' },
    { code: 'ga', langname: 'Irish' },
    { code: 'it', langname: 'Italian' },
    { code: 'ja', langname: 'Japanese' },
    { code: 'jw', langname: 'Javanese' },
    { code: 'kn', langname: 'Kannada' },
    { code: 'kk', langname: 'Kazakh' },
    { code: 'km', langname: 'Khmer' },
    { code: 'ko', langname: 'Korean' },
    { code: 'ku', langname: 'Kurdish (Kurmanji)' },
    { code: 'ky', langname: 'Kyrgyz' },
    { code: 'lo', langname: 'Lao' },
    { code: 'la', langname: 'Latin' },
    { code: 'lv', langname: 'Latvian' },
    { code: 'lt', langname: 'Lithuanian' },
    { code: 'lb', langname: 'Luxembourgish' },
    { code: 'mk', langname: 'Macedonian' },
    { code: 'mg', langname: 'Malagasy' },
    { code: 'ms', langname: 'Malay' },
    { code: 'ml', langname: 'Malayalam' },
    { code: 'mt', langname: 'Maltese' },
    { code: 'mi', langname: 'Maori' },
    { code: 'mr', langname: 'Marathi' },
    { code: 'mn', langname: 'Mongolian' },
    { code: 'my', langname: 'Myanmar (Burmese)' },
    { code: 'ne', langname: 'Nepali' },
    { code: 'ps', langname: 'Pashto' },
    { code: 'fa', langname: 'Persian' },
    { code: 'pl', langname: 'Polish' },
    { code: 'pt', langname: 'Portuguese' },
    { code: 'pa', langname: 'Punjabi' },
    { code: 'ro', langname: 'Romanian' },
    { code: 'ru', langname: 'Russian' },
    { code: 'sm', langname: 'Samoan' },
    { code: 'gd', langname: 'Scots Gaelic' },
    { code: 'sr', langname: 'Serbian' },
    { code: 'st', langname: 'Sesotho' },
    { code: 'sn', langname: 'Shona' },
    { code: 'sd', langname: 'Sindhi' },
    { code: 'si', langname: 'Sinhala' },
    { code: 'sk', langname: 'Slovak' },
    { code: 'sl', langname: 'Slovenian' },
    { code: 'so', langname: 'Somali' },
    { code: 'es', langname: 'Spanish' },
    { code: 'su', langname: 'Sundanese' },
    { code: 'sw', langname: 'Swahili' },
    { code: 'sv', langname: 'Swedish' },
    { code: 'tg', langname: 'Tajik' },
    { code: 'ta', langname: 'Tamil' },
    { code: 'te', langname: 'Telugu' },
    { code: 'th', langname: 'Thai' },
    { code: 'tr', langname: 'Turkish' },
    { code: 'uk', langname: 'Ukrainian' },
    { code: 'ur', langname: 'Urdu' },
    { code: 'uz', langname: 'Uzbek' },
    { code: 'vi', langname: 'Vietnamese' },
    { code: 'cy', langname: 'Welsh' },
    { code: 'xh', langname: 'Xhosa' },
    { code: 'yi', langname: 'Yiddish' },
    { code: 'yo', langname: 'Yoruba' },
    { code: 'zu', langname: 'Zulu' }
  ],
  accessToken: '',
  idToken: '',
  accessTokenExpires: '',
  serverAccessToken: '',
  refreshToken: '',
  callback: null,
  callbackstate: null,
  license: false,
  displayname: null,
  affiliation: '',
  picture: '',
  sid: ''
}
